var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "email-settings" },
    [
      _c(
        "sui-form",
        { attrs: { size: "small" } },
        [
          _c(
            "sui-grid",
            { attrs: { centered: "" } },
            [
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { centered: "", width: "six" } },
                    [
                      _c(
                        "sui-header",
                        { tag: "h2", staticClass: "email-form-header" },
                        [_vm._v("Email")]
                      ),
                      _c("span", [
                        _vm._v("Your current email address is "),
                        _c("strong", [_vm._v(_vm._s(_vm.user.email))]),
                        _vm._v("."),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "sui-grid-row",
                [
                  _c(
                    "sui-grid-column",
                    { attrs: { width: "six" } },
                    [
                      _c("sui-form-field", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.email,
                              expression: "email",
                              modifiers: { trim: true },
                            },
                          ],
                          attrs: { type: "email", placeholder: "Email" },
                          domProps: { value: _vm.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.email = $event.target.value.trim()
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _c(
                        "sui-grid-column",
                        { attrs: { centered: "", width: "eight" } },
                        [
                          _c("sui-button", {
                            attrs: {
                              type: "button",
                              basic: "",
                              color: "blue",
                              content: "Update email",
                              size: "small",
                            },
                            on: { click: _vm.save },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }